import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import CustomTable from '../../../elements/Table/CustomTable'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'

class List extends Component {
  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => (
        <Link to={`/clients/payments/${original._key}/deposit`} style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      ),
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Contract',
      accessor: 'code',
      Cell: ({ original, value }) => {
        return (
          <Link
            target={'_blank'}
            to={`/clients/${original.owner._id.replace('members/', '')}/contracts/${original._key}/view`}
            style={{ marginLeft: '10px' }}>
            {value}
          </Link>
        )
      },
    },
    {
      Header: 'company',
      accessor: 'company.fn',
    },
    {
      Header: 'Client',
      accessor: 'client.fn',
      width: 300,
    },
    {
      Header: 'title',
      accessor: 'title',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: MoneyCell,
    },
    {
      Header: 'Currency',
      accessor: 'pay.currency',
    },
  ]

  render() {
    const { fetching, list, fetch } = this.props
    return (
      <CustomTable
        columns={this.columns}
        data={list}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        defaultPageSize={20}
        style={{ minHeight: '512px' }}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
